module.exports = __webpack_public_path__ + "img/大事记logo2.a98a4043.png";